import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { ADD_BLOCK_OPTIONS } from './newContentManagementEditorConstants';
import { AddContentBlockButtonProps } from './newContentManagementEditorTypes';

export default function AddContentBlockButton({
  index,
  where,
  onAdd,
  emptyState = false,
}: AddContentBlockButtonProps) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', py: emptyState ? 1 : 0.5 }}>
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ color: 'text.secondary', fontSize: '12px' }}
        >
          {emptyState ? 'Add first block' : 'Add block'}
        </Button>
      </Box>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {ADD_BLOCK_OPTIONS.map((option) => (
          <MenuItem
            key={option.type}
            onClick={() => {
              onAdd(index, option.type, where);
              setAnchor(null);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
